module.exports = __webpack_public_path__ + "img/coffret-huitres-en-ligne-boutrais.2fec185b.png";